<template>
  <div class="single-what-news mb-70 auction-item">
    <div class="what-img">
      <img :src="data.DinhKem.length > 0 ? data.DinhKem[0].LinkDownload : ''" alt="" />
    </div>
    <div class="what-cap">
      <h4 v-if="data.Id == 201">
        <a href="#" class="ellipsis">Công ty Đấu giá Hợp danh Tân Đại Phát mời {{ data.PhienDauGia.TenKeHoach }}</a>
      </h4>
      <h4 v-else>
        <a href="#" class="ellipsis">{{ auctionType === 'home' ? data.PhienDauGia.TenKeHoach : data.TenTaiSan }}</a>
      </h4>
    </div>
    <div class="what-info">
      <div class="icon">
        <img src="@/assets/images/bua.svg" alt="" class="icon-bua" />
      </div>
      <div class="text">
        <span v-if="auctionType === 'room'">
          Thời gian bắt đầu:<strong>{{ data.PhienDauGia.BatDau | formatDate }}</strong>
        </span>
        <span>
          Giá khởi điểm:<strong>{{ data.GiaKhoiDiem.toLocaleString('da-DK') }} {{ data.PhienDauGia.DonViTinh }}</strong>
        </span>
        <span v-if="auctionType === 'home'">
          Bước Giá:<strong>{{ data.BuocGia.toLocaleString('da-DK') }} {{ data.PhienDauGia.DonViTinh }}</strong>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AuctionItem',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    auctionType: {
      type: String,
      default: () => 'home',
      validator: (value) => {
        return ['home', 'room'].includes(value);
      }
    }
  },
  filters: {
    formatDate: function(value) {
      if (!value) return '';
      return moment(String(value)).format('HH:mm:ss DD/MM/YYYY');
    }
  }
};
</script>

<style scoped>
.auction-item {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/AuctionItem.vue